/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Delete_SelectedInputs */

const es_sidebar_delete_selected = /** @type {(inputs: Sidebar_Delete_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar seleccionados`)
};

const en_sidebar_delete_selected = /** @type {(inputs: Sidebar_Delete_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete selected`)
};

/**
* | output |
* | --- |
* | "Delete selected" |
*
* @param {Sidebar_Delete_SelectedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_delete_selected = /** @type {((inputs?: Sidebar_Delete_SelectedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Delete_SelectedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_delete_selected(inputs)
	return en_sidebar_delete_selected(inputs)
});
export { sidebar_delete_selected as "sidebar.delete_selected" }